import { FC, HTMLProps } from 'react'
import Link, { LinkProps } from 'next/link'

interface IOriginLink extends LinkProps, Pick<HTMLProps<HTMLAnchorElement>, 'target' | 'style'> {
  className?: string
}

const OriginLink: FC<IOriginLink> = (props) => {
  return <Link {...props}>{props.children}</Link>
}

export default OriginLink
